import React from 'react'
import { Link } from 'react-router-dom'

import HeaderMeta from 'components/HeaderMeta'

import Content from 'components/base/Content'
import Loading from 'components/base/Loading'
import Paragraph from 'components/base/Paragraph'

import PageHero, { Theme as PageHeroTheme } from 'components/blocks/PageHero'
import List from 'components/base/List'

import {
  Props, PageProps,
} from './types'

const SiteMap: React.FC<Props> = ({
  loading,
  pages,
}): React.ReactElement => (
  <div>
    <HeaderMeta
      title='Site Map | Insurance Lounge'
      description='Insurance Lounge Site Map.'
    />
    <PageHero theme={PageHeroTheme.noimage}>Site Map</PageHero>
    <Content margined={true} short={true}>
      {(loading && <Loading />) || (!pages && <Paragraph>Unable to load site map.</Paragraph>) || (
        <List>
          {pages.map((page: PageProps) => (
            <li key={page.relativeUrl}>
              <Link to={page.relativeUrl}>{page.absoluteUrl}</Link>
            </li>
          ))}
        </List>
      )}
    </Content>
  </div>
)

export default SiteMap
